export default "__VITE_ASSET__e9f8c3ef__"